import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export function NavAccount({ sx, ...other }) {
  const { user } = useAuthContext();

  const contact = user?.email ?? user?.mobile ?? user?.phoneNumber ?? 'راه ارتباطی ثبت نشده';
  const displayName = user?.displayName ?? 'کاربر رادو';

  return (
    <Stack sx={{ px: 2, py: 5, textAlign: 'center', ...sx }} {...other}>
      <Stack alignItems="center">
        <Avatar src={user?.photoURL} alt={displayName} sx={{ width: 48, height: 48 }}>
          {displayName.charAt(0).toUpperCase()}
        </Avatar>

        <Stack spacing={0.5} sx={{ mb: 2, mt: 1.5, width: 1 }}>
          <Typography
            variant="subtitle2"
            noWrap
            sx={{ color: 'var(--layout-nav-text-primary-color)' }}
          >
            {displayName}
          </Typography>

          <Typography
            variant="body2"
            noWrap
            dir="ltr"
            sx={{ color: 'var(--layout-nav-text-disabled-color)' }}
          >
            {contact}
          </Typography>
        </Stack>

        <Button variant="contained" component={RouterLink} href={paths.dashboard.profile}>
          حساب کاربری
        </Button>
      </Stack>
    </Stack>
  );
}
